import { db } from '../../config/Fire'
import * as Constants from '../../constants'

export const SET_INVENTORY = 'SET_INVENTORY'
export const SET_NEW_INVENTORY = 'SET_NEW_INVENTORY'
export const REMOVE_ITEM_INVENTORY = 'REMOVE_ITEM_INVENTORY'
export const EDIT_ITEM_INVENTORY = 'EDIT_ITEM_INVENTORY'

const setInventory = payload => ({ type: SET_INVENTORY, payload })
const setNewInventory = payload => ({ type: SET_NEW_INVENTORY, payload })
const removeInventory = payload => ({ type: REMOVE_ITEM_INVENTORY, payload })
const editInventory = payload => ({ type: EDIT_ITEM_INVENTORY, payload })

export const loadInventory = payload => {
    return async dispatch => {
        try {
            const inventoryRef = await db.ref(`${Constants.MAIN_NODES.INVENTORY}`).once('value')
            const inventoryMap = {}
            if (inventoryRef.exists()) {
                inventoryRef.forEach(elementRef => {
                    const element = elementRef.val()
                    inventoryMap[element.id] = element
                })
            }
            dispatch(setInventory(inventoryMap))
            return true
        } catch (e) {
            console.log(e)
            return false
        }
    }
}

export const newItemInventory = payload => {
    return async dispatch => {
        const inventory = payload
        const pushInventoryRef = db.ref(`${Constants.MAIN_NODES.INVENTORY}`).push()
        inventory.id = pushInventoryRef.key
        try {
            await pushInventoryRef.set(inventory)
            dispatch(setNewInventory(inventory))
            return true
        } catch (e) {
            console.log(e)
            return false
        }
    }
}

export const removeItemInventory = payload => {
    return async dispatch => {
        try {
            await db.ref(`${Constants.MAIN_NODES.INVENTORY}`).child(payload.id).remove()
            dispatch(removeInventory(payload))
            return true
        } catch (e) {
            console.log(e)
            return false
        }
    }
}

export const editItemInventory = payload => {
    return async dispatch => {
        try {
            await db.ref(`${Constants.MAIN_NODES.INVENTORY}`).child(payload.id).update({ ...payload })
            dispatch(editInventory(payload))
            return true
        } catch (e) {
            console.log(e)
            return false
        }
    }
}
